import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
    Typography,
} from "@mui/material";
import useAxios from "../../../../hooks/useAxios";
import './StudentAddQuizModal.css';
import StyledTextField from '../../../common/StyledComponents/StyledTextField';

const StudentAddQuizModal = ({ open, onClose }) => {
    const [uniqueIdentifier, setUniqueIdentifier] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const axiosInstance = useAxios();

    const handleSubmit = async () => {
        setError(null);
        setLoading(true);
        try {
            const response = await axiosInstance.post("/classes/add-student", {
                unique_identifier: uniqueIdentifier,
            });
            if (response.data.success) {
                onClose(true); // Close modal and refresh quizzes
            } else {
                setError(response.data.message || "Failed to add quiz.");
            }
        } catch (err) {
            setError(err.response?.data?.message || "An unexpected error occurred.");
        } finally {
            setLoading(false);
            setUniqueIdentifier(null);
        }
    };

    const handleClose = () => {
        setUniqueIdentifier(null);
        onClose(false);
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} fullWidth>
            <DialogTitle className="announcement">Add a Quiz</DialogTitle>
            <Typography className="modal-text">Use the unique identifier provided by the quiz owner</Typography>
            <DialogContent>
                <StyledTextField
                    fullWidth
                    label="Unique Identifier"
                    value={uniqueIdentifier}
                    onChange={(e) => setUniqueIdentifier(e.target.value)}
                    margin="normal"
                    error={!!error}
                    helperText={error}
                />
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleClose} 
                    disabled={loading}
                    className="secondary-button"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={loading || !uniqueIdentifier?.trim()}
                    startIcon={loading && <CircularProgress size={20} />}
                    className="primary-button"
                >
                    {loading ? "Adding Quiz" : "Submit"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StudentAddQuizModal;
